{
  "tabs": {
    "overview": "Resumen general",
    "subaccount": "Subcuentas",
    "affiliates": "Afiliados",
    "transfers": "Transferencias",
    "ledger": "Libro mayor",
    "documents": "Documentos",
    "portfolio": "Cartera",
    "trades": "Transacciones"
  },
  "highlights": {
    "goalType": "Tipo de meta: {{goalType}}",
    "timeHorizon": "Horizonte temporal: {{timeHorizon}}",
    "targetAmount": "Objetivo: {{amount}}",
    "riskPreference": "Preferencia de riesgo: {{level}}",
    "riskLevel": {
      "LEVEL_1": "Nivel 1",
      "LEVEL_2": "Nivel 2",
      "LEVEL_3": "Nivel 3",
      "LEVEL_4": "Nivel 4",
      "LEVEL_5": "Nivel 5"
    },
    "suitabilityScore": "Puntuación de idoneidad: {{score}}",
    "goalPortfolio": "Cartera de meta",
    "tradingProcess": "Proceso de operación"
  },
  "timeHorizonDescription": {
    "VERY_SHORT_TERM": "Menos de 1 año",
    "SHORT_TERM": "1 - 3 años",
    "MID_TERM": "4 - 6 años",
    "LONG_TERM": "7+ años"
  },
  "linkedSubAccount_one": "1 subcuenta vinculada",
  "linkedSubAccount_other": "{{count}} subcuentas vinculadas",
  "percentageOfTotalAssets": "{{percentage}} del total de activos",
  "riskReturnLevel": "Nivel de riesgo y rentabilidad de {{count}}",
  "autoTransferNotSet": "Transferencia automática no configurada",
  "autoTransferEnabled_one": "Transferencia automática habilitada en 1 cartera",
  "autoTransferEnabled_other": "Transferencia automática habilitada en {{count}} carteras",
  "editGoal": "Editar meta",
  "dissociateGoalFromHousehold": "Desvincularse del hogar",
  "edit": {
    "title": "Información sobre la meta",
    "goalType": "Tipo de meta",
    "targetAmount": "Importe de meta",
    "timeHorizon": "Horizonte temporal",
    "riskPreference": "Preferencia de riesgo"
  },
  "holdings": "Activos",
  "renameGoal": "Cambiar nombre de meta",
  "closeGoal": "Cerrar meta",
  "restoreGoal": "Restaurar meta",
  "activeGoal": "Activar meta",
  "closedGoal": "Meta cerrada",
  "closeGoalDialog": {
    "title": "¿Está seguro?",
    "subtitle": "¿Está seguro de que quiere cerrar esta meta?",
    "continueButton": "Sí, estoy seguro",
    "cancelButton": "Cancelar"
  },
  "toastMessage": {
    "error": "Algo salió mal",
    "success": "La meta se ha cerrado con éxito",
    "restoreSuccess": "Ha reactivado esta meta"
  },
  "closeGoalConfirmationDialog": {
    "title": "No se puede cerrar la meta",
    "subtitle": "Debe cerrar todas las subcuentas y cancelar cualquier depósito programado antes de continuar",
    "continueButton": "Vale, entendido"
  },
  "household": "Hogar",
  "changeToHouseholdGoal": "Cambiar a «{{name}}» meta del hogar",
  "associateToHouseholdDialog": {
    "title": "¿Asociar esta meta al hogar de {{name}}?",
    "checkingSubaccounts": "Comprobación de las subcuentas de la meta",
    "thereAreSubAccounts": "Todas las cuentas y subcuentas vinculadas también se trasladarán al hogar. Esto incluye:",
    "thereAreNoSubAccounts": "¿Está seguro de que quiere trasladar esta meta al hogar?",
    "linkGoalToHousehold": "Esta meta no está asociada actualmente a ninguna subcuenta. Por favor, asócielo primero a una subcuenta. Una vez hecho esto, podrá añadir la meta al hogar.",
    "continueButton": "Sí, estoy seguro",
    "gotItButton": "Vale, entendido",
    "cancelButton": "Cancelar",
    "success": "La meta se ha asociado al hogar.",
    "createSubAccount": "Crear subcuenta"
  },
  "dissociateGoalDialog": {
    "checkingSubaccounts": "Comprobación de las subcuentas de la meta",
    "title": "¿Desvincular este objetivo del hogar {{name}}?",
    "continueButton": "Sí, estoy seguro",
    "cancelButton": "Cancelar",
    "thereAreSubAccounts": "Todas las cuentas y subcuentas vinculadas también se eliminarán del hogar. Esto incluye:",
    "thereAreNoSubAccounts": "¿Está seguro de que quiere borrar esta meta al hogar?",
    "success": "La meta se ha disociado del hogar."
  }
}
